import { Schema } from '@core/data/dto/schema';

export const EmployeeProviderMetadataSchema = {
    oss_id: Schema.String
}
